module.exports = __webpack_public_path__ + "static/media/rsna18-group-1.c19c1331.svg";